import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    APIRoleClaimMembershipDelete,
    APIRoleClaimMembershipGetList,
    APIRoleClaimMembershipPost,
    APIRoleClaimMembershipPostParams,
    APIRoleClaimMembershipPostResponse,
    APIRoleClaimMembershipPut,
    APIRoleClaimMembershipPutParams,
    APIRoleClaimMembershipPutResponse
} from './RoleClaimMembership.api';

export type RoleClaimMembershipExtended = {
    id: string;
    name: string;
    claimDataTypeName: string;
}

export const fetchRoleClaimMemberships = createAsyncThunk('role-claim/fetchRoleClaimMemberships', async (params: { tenantId: string, roleId: string, signal?: AbortSignal }) => {
    const response = await APIRoleClaimMembershipGetList(params);
    return response.data.map(item => ({
        ...item,
        id: `${item.claimId}`,
        name: item.claimName,
        claimDataTypeName: item.claimDataTypeName,
    }));
});

export type PostRoleClaimMembershipThunkResponse = {
    item: APIRoleClaimMembershipPostParams,
    response: APIRoleClaimMembershipPostResponse,
    rows: RoleClaimMembershipExtended[]
}

export const postRoleClaimMembership = createAsyncThunk(
    'role-claim/postRoleClaimMembership',
    async (item: APIRoleClaimMembershipPostParams) => {
        const response = await APIRoleClaimMembershipPost(item);
        const rows = await handleListFetch(APIRoleClaimMembershipGetList({ tenantId: item.tenantId, roleId: item.roleId }));
        return {
            item,
            response,
            rows: rows.map(row => ({
                ...row,
                id: `${row.roleId}.${row.claimId}`,
                name: row.claimName,
                claimDataTypeName: row.claimDataTypeName
            })),
        };
    }
);

export type PutRoleClaimMembershipThunkResponse = {
    item: APIRoleClaimMembershipPutParams,
    response: APIRoleClaimMembershipPutResponse,
    rows: RoleClaimMembershipExtended[]
}

export const putRoleClaimMembership = createAsyncThunk(
    'role-claim/putRoleClaimMembership',
    async (item: APIRoleClaimMembershipPutParams) => {
        const response = await APIRoleClaimMembershipPut(item);
        const rows = await handleListFetch(APIRoleClaimMembershipGetList({ tenantId: item.tenantId, roleId: item.roleId }));
        return {
            item,
            response,
            rows: rows.map(row => ({
                ...row,
                id: `${row.roleId}.${row.claimId}`,
                name: row.claimName,
                claimDataTypeName: row.claimDataTypeName
            })),
        };
    }
);

export const deleteRoleClaimMembership = createAsyncThunk('role-claim/fetchRoleClaimMemberships', async (item: { tenantId: string, roleId: string, claimId: string}) => {
    const response = await APIRoleClaimMembershipDelete(item);
    const rows = await handleListFetch(APIRoleClaimMembershipGetList({ tenantId: item.tenantId, roleId: item.roleId }));
    return {
        response,
        rows: rows.map(row => ({
            ...row,
            id: `${row.roleId}.${row.claimId}`,
            name: row.claimName,
            claimDataTypeName: row.claimDataTypeName
        })),
    };
});
